<template>
  <header class="relative z-50 bg-transparent">
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div>
      <nav class="bg-gradient-to-b from-black to-transparent">
        <div class="max-w-8xl mx-auto px-20 sm:p-0">
          <router-link to="/"
            ><img
              class="h-20 w-52 sm: w-44 inline-flex sm:pl-8"
              :src="require('../assets/images/logo.svg')"
              alt="sushi-shogun"
            />
          </router-link>
          <div class="inline-flex items-center h-16 w-4/5 sm:w-1/5 sm:float-right sm:pt-4 sm:pr-8 justify-end">
            <div class="flex items-center">
              <div class="flex-shrink-0"></div>
              <div class="block md:hidden">
                <div class="ml-10 flex items-baseline">
                  <!-- Current: "underline bg-gray-900 text-white", Default: "underline text-gray-300 hover:bg-gray-700 hover:text-white" -->
                  <router-link
                    to="About"
                    class="pb-2 menu-item-border text-white px-1 mx-14 font-medium menu-font"
                    >ABOUT US</router-link
                  >

                  <router-link
                    to="Contact-us"
                    class="text-white menu-item-border px-1 mx-12 font-medium menu-font"
                    >CONTACT</router-link
                  >

                  <router-link
                    to="Menu"
                    class="text-white menu-item-border px-1 mx-14 font-medium menu-font"
                    >MENU</router-link
                  >
                </div>
              </div>
            </div>

            <div class="-mr-2 md:flex hidden">
              <!-- Mobile menu button -->
              <button
                class="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
              @click="toggle"
              aria-expanded="false"
              >
                <span class="sr-only">Open main menu</span>
                <!--
              Heroicon name: menu

              Menu open: "hidden", Menu closed: "block"
            -->
                <svg
                  :class=menuBurger
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
                <!--
              Heroicon name: x

              Menu open: "block", Menu closed: "hidden"
            -->
                <svg
                  :class=menuClose
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!--
      Mobile menu, toggle classes based on menu state.

      Open: "block", closed: "hidden"
    -->
        <div :class=menuClass>
          <div class="px-2 pt-2 pb-3 space-y-1 bg-black h-screen sm:px-8">
            <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
            <router-link
                    to="home"
                    class="text-white block px-1 rounded-md text-base font-medium menu-font py-8"
                    @click="toggle"
                    >Home</router-link
                  >
           <router-link
                    to="About"
                    class="text-white block px-1 rounded-md text-base font-medium menu-font py-8"
                    @click="toggle"
                    >ABOUT US</router-link
                  >

                  <router-link
                    to="Contact-us"
                    class="text-white block px-1 rounded-md text-base font-medium menu-font py-8"
                    @click="toggle"
                    >CONTACT</router-link
                  >

                  <router-link
                    to="Menu"
                    class="text-white block px-1 rounded-md text-base font-medium menu-font py-8"
                    @click="toggle"
                    >MENU</router-link
                  >

     <div class="w-3/12 sm:w-full px-20 sm:px-1 sm:py-20">
        <div class="">
          <div class="phone">Phone</div>
          <div class="phone-content">604-498-6388</div>
        </div>

        <div class="">
          <div class="phone">Address</div>
          <div class="phone-content">
            13591 King George Blvd. Surrey, B.C. V3T 2V1
          </div>
        </div>
      

    
        <div class="">
          <div class="phone">Email</div>
          <div class="phone-content">sushishogun@gmail.com</div>
        </div>

        </div>
           
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
   data() {
      return {
        menuToggle:false,
        menuClass:"hidden md:hidden",
        menuClose:"hidden md:hidden h-6 w-6",
        menuBurger:"hidden md:block h-6 w-6"
      }
    },
  methods: {
   
    toggle(){
      if(this.menuToggle == false){
      this.menuToggle = true
      this.menuClass = "md:block"
      this.menuClose = "block md:block h-6 w-6"
      this.menuBurger = "hidden md:hidden h-6 w-6"
    }else{
      this.menuToggle=false
      this.menuClass = "hidden md:hidden"
      this.menuClose = "md:hidden h-6 w-6"
      this.menuBurger = "md:block h-6 w-6"
    }
  },
}}
</script>

<style>
@font-face {
  font-family: avenirLight;
  font-weight: 300;
  font-style: normal;
  font-display: auto;
  src: url("../assets/fonts/Avenir-Light.ttf") format("truetype");
}
.menu-item-border:hover {
  position: relative;
}
.menu-item-border:hover:after {
  content: "";
  display: block;
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(255, 255, 255);
  width: 0;
  position: absolute;
  right: 0;
  -webkit-transition: 2s all ease;
  transition: 2s all ease;
}

.menu-item-border:hover:hover:after {
  width: 100%;
}
.menu-font {
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 1.25rem;
  line-height: 36px;
  /* identical to box height, or 150% */

  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}
</style>